import React from 'react';
import { ExperimentStatus } from 'apps/experiments/src/types';
import { useStagedExperiment } from 'iron/apps/experiments/src/components/hooks/staged-experiment';
import { ExperimentPageBannerConfigure } from './_configure';
import { ExperimentPageBannerRunning } from './_running';
import { ExperimentPageBannerReview } from './_review';
import { ExperimentPageBannerSucceeded } from './_succeeded';
import { ExperimentPageBannerFailed } from './_failed';
export function ExperimentPageBanner() {
  const {
    stagedExperiment: experiment
  } = useStagedExperiment();
  if (!experiment) {
    return null;
  }
  switch (experiment.status) {
    case ExperimentStatus.DRAFT:
      return <ExperimentPageBannerConfigure />;
    case ExperimentStatus.ACTIVE:
      return <ExperimentPageBannerRunning />;
    case ExperimentStatus.CONCLUDED:
      return <ExperimentPageBannerReview />;
    case ExperimentStatus.SUCCESS:
      return <ExperimentPageBannerSucceeded />;
    case ExperimentStatus.FAIL:
      return <ExperimentPageBannerFailed />;
    default:
      return null;
  }
}